import alarms from "./alarms";

export default {
    alarms
};
